export const SIGNUP_LIST = [
  {
    qsymbol: '[Q]',
    question: '휴대폰 인증이 무엇인가요?',
    asymbol: '[A]',
    answer: `휴대폰 인증을 통하여 정확한 연락처임이 증명된 마크를 부여받는 제도입니다. 잘못된 연락처를 입력하여 업체로부터 면접제의를 받지 못하는 실수를 줄이기 위한 인증서비스입니다. 또한 신규 회원가입을 하거나 이미 가입된 회원정보수정에서 휴대폰 인증이 가능합니다. Tip. 휴대폰 인증마크가 있는 이력서는 정확한 정보인 이력서로 인식되어 미인증 이력서보다 더 많은 취업의 기회를 얻을 수 있습니다.`,
  },
  {
    qsymbol: '[Q]',
    question: '개인 회원가입은 무료인가요?',
    asymbol: '[A]',
    answer: `Encer의 개인회원 가입은 무료이며, 별도의 회원가입비를 받지 않습니다. 현재 비회원 시 영구적으로 프로젝트 1회 열람의 서비스만 제공되지만 무료 회원가입을 하시게 될 경우 프로젝트 무한 무료열람 서비스 제공과 입찰 참여의 서비스를 제공해드립니다. 회원가입은 휴대폰 인증 후 이름, 생년월일, 이메일, 휴대폰번호 등의 개인정보를 입력하시면 Encer의 개인회원으로 가입하실 수 있습니다. [개인회원가입하기]`,
  },
];
